import { Component, Output, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';
import { SubscriptionLike } from 'rxjs';

import { NotificationService, SessionStorageService } from "@shared/services";

@Component({
  selector:    'pagination',
  templateUrl: 'pagination.component.html',
  host: { class: 'am-flex-align am-flex-justify p-s', '[class.display-none]': '!loading && !totalCount' },
  styleUrls: ['./pagination.component.sass'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PaginationComponent {
  @Input() id:      string;
  @Input() loading: boolean;
  @Output() callback = new EventEmitter<any>();
  subscriptions: SubscriptionLike[] = [];

  paginationOptions: number[] = [10,25,50];

  itemsPerPage: number;
  totalCount: number;
  constructor(
    private notificationService: NotificationService,
    private sessionStorageService: SessionStorageService
  ) { }

  ngOnInit() {
    this.subscriptions.push(this.sessionStorageService.itemsPerPage.subscribe(items => this.itemsPerPage = items));
    this.subscriptions.push(this.sessionStorageService.totalCount.subscribe(count => this.totalCount = count));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(
      (subscription) => subscription.unsubscribe());
    this.subscriptions = [];
  }

  changePage(p: number): void {
    this.sessionStorageService.changePageNumber(p);
    if (this.callback.observers.length) this.callback.emit();
  }

  changeItemsPerPage(p: number): void {
    this.sessionStorageService.changePageNumber(1);
    this.sessionStorageService.changeItemsPerPage(p);
    if (this.callback.observers.length) this.callback.emit();
  }
}
